import { cx } from "classix"
import styles from "~/shared/ui/components/panels/InfoPanel/index.module.css"
import type { ComponentProps, CSSProperties, PropsWithChildren, ReactNode, RefObject } from "react"

export type PanelProps = {
	header?: ReactNode,
	bottom?: ReactNode,
	headerStyle?: CSSProperties,
	contentStyle?: CSSProperties,
	bottomStyle?: CSSProperties,
	headerClassName?: string,
	contentClassName?: string,
	bottomClassName?: string,
	rootRef?: RefObject<HTMLDivElement>
} & PropsWithChildren & ComponentProps<"div">

/**
 * Для отображения контента
 */
export function Panel({
						  header,
						  bottom,
						  className,
						  headerStyle, headerClassName,
						  contentStyle, contentClassName,
						  bottomStyle, bottomClassName,
						  children,
						  rootRef,
						  ...divProps
					  }: PanelProps) {


	return <div ref={rootRef} className={cx(styles.root, className)} {...divProps}>
		{header && <h4 className={cx(styles.header, headerClassName)} style={headerStyle}>{header}</h4>}
		<div className={cx("flex-[1_0_auto]", contentClassName)} style={contentStyle}>
			{children}
		</div>
		{bottom && <div className={cx(styles.actionBlock, bottomClassName)} style={bottomStyle}>{bottom}</div>}
	</div>
}